
import React from 'react';
import { LoadingSpinnerIcon } from './icons';

interface LoadingIndicatorProps {
  message?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-slate-800 bg-opacity-50 rounded-lg">
      <LoadingSpinnerIcon className="w-12 h-12 text-cyan-400" />
      <p className="mt-4 text-lg text-slate-300 font-orbitron">{message}</p>
    </div>
  );
};

export default LoadingIndicator;
